/**
 * Return whether the given number is an integer or almost.
 *
 * @example
 * isIntegerOrAlmost(9.5); // false
 * isIntegerOrAlmost(10.00000223); // true
 * isIntegerOrAlmost(-10); // true
 *
 * @param {!number} n - the integer to test
 * @return {!boolean}
**/
const isIntegerOrAlmost = n => Math.abs(n - Math.round(n)) < 1e-6;

/**
 * Return the formatted price
 * Note that we might have to change that later for different currencies.
 *
 * @example
 * formatNumber(12.000003); // returns "12"
 * formatNumber(12.100003); // returns "12.1"
 *
 * @param {!number} price - the price amount to convert
 * @return {!string} the formatted price
**/
const formatPrice = price => price.toFixed(isIntegerOrAlmost(price) ? 0 : 2);

export default formatPrice;
